import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { ConfigService } from '../../../../core/services/config.service';
import { RequestService } from '../../../../core/services/request.service';

import { TaxationDataDetails } from './details/taxation-data-details.model';

@Injectable()
export class TaxationDataService {

   constructor(
    private configService: ConfigService,
    private requestService: RequestService
  ) { }

  delete(details: any): Observable<TaxationDataDetails> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.taxData.delete.api;
        return this.requestService.post(url, details);
  }
  getTaxationDataDetails(id: string): Observable<TaxationDataDetails> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.taxData.details.api + '/' + id;
        return this.requestService.get(url);
  }
  getFields() {
     let fields = [
        {
            key: 'id',
            label: 'ID',
            type: 'hidden',
            required: false
        }, {
            key: 'taxCountry',
            label: 'Tax Country',
            type: 'textbox',
            required: false
        }, {
            key: 'taxNumber',
            label: 'Tax Number',
            type: 'textbox',
            required: false
        }, {
            key: 'taxNumberType.id',
            label: 'Tax Number Type',
            type: 'dropdown',
            required: false,
            dictionaryUrl:
                    this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.taxNumber.api
        }
     ];
     return fields;
  }

  getDetailsFields() {
      let fields = [
        {
            key: 'taxCountry',
            label: 'Tax Country',
            type: 'text'
        }, {
            key: 'taxNumber',
            label: 'Tax Number',
            type: 'text'
        }, {
            key: 'taxNumberType.configValue',
            label: 'Tax Number Type',
            type: 'text'
        }
     ];
     return fields;
  }

}



// WEBPACK FOOTER //
// ./src/app/agora/components/account-data/taxation-data/taxation-data.service.ts